import { render, staticRenderFns } from "./choosepages.vue?vue&type=template&id=404e6075&scoped=true"
import script from "./choosepages.vue?vue&type=script&lang=ts"
export * from "./choosepages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404e6075",
  null
  
)

export default component.exports